import { Button } from "@/components/ui/button";
import { MessageCircle, Phone } from "lucide-react";
import { COMPANY } from "@/lib/company";
import { trackWhatsApp, trackPhone } from "@/lib/track";

export default function WhatsAppCTA() {
  return (
    <section
      id="whatsapp-cta"
      data-testid="whatsapp-cta-section"
      className="py-20 lg:py-28 bg-[#25D366]/5 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,#25D36615,transparent_70%)]" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 bg-[#25D366]/10 border border-[#25D366]/30 text-[#128C7E] text-[11px] uppercase tracking-[0.25em] font-semibold">
          <MessageCircle className="w-3.5 h-3.5" /> Quickest Way
        </div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-5 leading-[1.1]">
          The Quickest Way to Your Rough Estimate
        </h2>
        <p className="text-base lg:text-lg text-neutral-600 leading-relaxed mb-9 max-w-2xl mx-auto">
          Send us photos or videos of your property on WhatsApp and tell us what you want to renovate. We&apos;ll review them and come back with a rough preliminary estimate — then arrange a free site inspection for the actual price.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-3">
          <a href={COMPANY.estimateLink} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-cta-primary" onClick={() => trackWhatsApp("whatsapp_section")}>
            <Button className="bg-[#25D366] hover:bg-[#1ebd5a] text-white rounded-none px-8 py-8 text-base font-semibold w-full sm:w-auto tracking-wide">
              <MessageCircle className="w-5 h-5 mr-2" /> WHATSAPP US
            </Button>
          </a>
          <a href={`tel:${COMPANY.phoneIntl}`} data-testid="whatsapp-cta-call" onClick={() => trackPhone("whatsapp_section")}>
            <Button variant="outline" className="rounded-none border-neutral-900 text-neutral-900 hover:bg-neutral-900 hover:text-white px-8 py-8 text-base font-medium w-full sm:w-auto tracking-wide">
              <Phone className="w-5 h-5 mr-2" /> CALL NOW
            </Button>
          </a>
        </div>

        <p className="mt-6 text-xs text-neutral-500">Direct line to a renovation coordinator · Fast reply · No obligation</p>
      </div>
    </section>
  );
}
